// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(min-width:1050px){.event-buybox[data-v-396cf307]{margin-top:-30px}}@media(min-width:550px)and (max-width:1050px){.event-buybox[data-v-396cf307]{margin-top:-20px}}.encounter-list[data-v-396cf307]{margin-top:24px}.competition-name[data-v-396cf307]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}", ""]);
// Exports
module.exports = exports;
